
import { Component, Mixins } from 'vue-property-decorator';
import { mapState } from 'vuex';
import LayoutDefault from '@/layouts/LayoutDefault.vue';
import MfaWarning from '@/components/authentication/MfaWarning.vue';
import Helpers from '@/logic/orders/helpers';
import TablePagination from '@/components/table/TablePagination.vue';
import ValueCell from '@/components/table/ValueCell.vue';
import TableMixin from '@/mixins/TableMixin';
import InvoiceDetails from '@/components/invoices/InvoiceDetails.vue';
import ShowSalesOrder from '@/components/invoices/ShowSalesOrder.vue';
import InvoiceStatus from '@/components/invoices/InvoiceStatus.vue';
import InvoicesActionBar from '@/components/invoices/InvoicesActionBar.vue';
import BaseCurrencyAmount from '@/components/BaseCurrencyAmount.vue';

@Component({
  components: {
    BaseCurrencyAmount,
    InvoicesActionBar,
    InvoiceStatus,
    LayoutDefault,
    MfaWarning,
    ValueCell,
    TablePagination,
    InvoiceDetails,
    ShowSalesOrder,
  },
  computed: { ...mapState('invoice', ['invoices', 'perPage', 'currentPage']) },
})
export default class MyInvoices extends Mixins(TableMixin) {
  detailKey = 'Id';

  fetchAction = 'invoice/fetchInvoices';

  Helpers = Helpers;

  get sort() {
    return this.$store.state.invoice.sort.split('+');
  }

  get sortField(): string {
    return this.sort[0];
  }

  get sortOrder(): string {
    return this.sort[1] === 'desc' ? 'desc' : 'asc';
  }

  get hasMfa(): boolean {
    return this.$store.getters['auth/hasMfa'];
  }

  get isLoading(): boolean {
    return this.$store.getters['invoice/isLoading'];
  }

  onSort(field: string, order: string) {
    const sort = field + (order === 'desc' ? '+desc' : '');
    this.$store.dispatch('invoice/sort', sort);
  }

  beforeDestroy(): void {
    this.$store.commit('invoice/resetState');
  }
}
